import { QueryModelValidator } from '../models/query-model-validator';
import { EntityType } from '../../../const';

export default {
    provide() {
        const { getQueryEntityError: $getQueryEntityError } = this;
        return {
            $getQueryEntityError
        };
    },
    data() {
        return {
            queryModelValidation: {
                /** @type {ValidationError[]} */
                errors: []
            }
        };
    },
    watch: {
        'queryModelValidation.errors'(errors) {
            this.$handleError(errors, true, 'dataset-query-editor');
        }
    },
    computed: {
        queryModelIsValid() {
            const { queryModelValidation: { errors } } = this;
            return errors.length === 0;
        },
        /**
         * @return {QueryModelValidator}
         */
        queryModelValidator() {
            const { queryModel, datasetInfo } = this;
            return new QueryModelValidator({ queryModel, datasetInfo });
        },
        /**
         * @return {Record<EntityTypeEnum[keyof EntityTypeEnum], Record<string, ValidationError>>}
         */
        errorsDetails() {
            return this.queryModelValidation.errors.reduce((acc, { data }) => {
                Object.entries(data).forEach(([prop, details]) => {
                    acc[prop] = {
                        ...acc[prop],
                        ...details
                    };
                });
                return acc;
            }, {});
        },
        /**
         * @return {string[]}
         */
        errorEntityNames() {
            const errorsMap = this.getSectionErrors([EntityType.METRIC, EntityType.DIMENSION]);
            return Object.keys(errorsMap ?? {});
        }
    },
    methods: {
        /**
         * @param {EntityTypeEnum[keyof EntityTypeEnum]} sections
         * @return {boolean}
         */
        isQuerySectionHasError(sections) {
            return [sections].flat().some((section) => this.errorsDetails[section] != null);
        },
        /**
         *
         * @param {EntityTypeEnum[keyof EntityTypeEnum][]} sections
         * @return {Record<string, { message: MessageI18n }>}
         */
        getSectionErrors(sections) {
            sections = [sections].flat().filter(this.isQuerySectionHasError);
            return sections.reduce(
                (acc, section) => ({
                    ...acc,
                    ...this.errorsDetails[section]
                }),
                {}
            );
        },
        /**
         *
         * @param {EntityTypeEnum[keyof EntityTypeEnum][]} sections
         * @param {string} name
         * @return {null | { message: MessageI18n }}
         */
        getQueryEntityError(sections, name) {
            sections = [sections].flat().filter((section) => this.errorsDetails[section] != null);
            const errorsMap = this.getSectionErrors(sections);
            return errorsMap[name] ?? null;
        },
        /**
         *
         */
        validateQueryModel() {
            this.queryModelValidation.errors = [...this.queryModelValidator.validate(), ...this.queryModel.validate()];
        }
    }
};
